import currencyFormatter from 'currency-formatter'
export default {
  name: 'regExp',
  htmlCommentSingle: /<!--(.*?)-->/gm,
  naturalNumber: /^[1-9]\d*$/,
  expEmail: /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/,
  expPhone: /^\d{2,3}-\d{3,4}-\d{4}$/,
  image: /(png|jpeg|svg|jpg|gif)$/,
  video: /(mp4|ogg|webm)$/,
  numberOnly: function (num) {
    return num.toString().replace(/[^0-9.]/g, '')
  },
  priceOnly: function (num) {
    return num.toString().replace(/[^0-9.]/g, '')
  },
  comma: function (num) {
    const reg = /^([-+]?\d+)(\d{3})(\.\d+)?/
    let string = num != null
      ? '' + Math.round(num * 100) / 100
      : ''
    string = string.replace(/[^-+.\d]/g, '')
    while (reg.test(string)) string = string.replace(reg, '$1' + ',' + '$2' + '$3')
    return string
  },
  uncomma: function (str) {
    str = `${str}`
    return str.replace(/[^-.\d]/g, '')
  },
  replaceAllEmpty: function (str) {
    str = `${str}`
    return str.replace(/(\s*)/g, '').toLowerCase()
  },
  priceFormat: function (price, code) {
    const format = currencyFormatter.format(price, { code: code })
    const formatArr = format.split('')
    const regex = new RegExp(/[0-9]/)
    const firstNumber = formatArr.findIndex((e) => regex.test(e))
    formatArr[firstNumber] = ' ' + formatArr[firstNumber]
    return formatArr.join('')
  },
  priceUnFormat: function (price, code) {
    return currencyFormatter.unformat(price, { code: code })
  },
  fillPad: function (str, length, pad) { // 남는 자리수만큼 pad로 채움 (없으면 0)
    str = `${str}`
    return str.length >= length ? str : new Array(length - str.length + 1).join(pad || '0') + str
  }
}
